module.exports = __webpack_public_path__ + "img/676bf8fd75d5e8065b632ba84fc55385.png";